import './App.css';

import 'bootstrap/dist/css/bootstrap.min.css';



import Snowfall from 'react-snowfall'
import {Helmet} from "react-helmet";
import Navbars from './NavbarPrice';
import { Banner } from './Banner';
import Price from './price';
import { Footer } from './Footer';
import { Banner1 } from './banner1';
import { FooterPrice } from './FooterPrice';

export const PriceList = () => {
  return (
    <>
        <Snowfall
          snowflakeCount={0}

      />
      <Navbars/>
      <Banner1/>
      <Price/>
      {/* 
      
      
      
      <FooterPrice/>
      
      
      */}
      
      </>

  )
}



